import { Component } from '@angular/core';
import { PeriodDto } from '@models/users/period.dto';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'ebs-sequence-validator-dialog',
  templateUrl: './sequence-validator-dialog.component.html',
  styleUrls: ['./sequence-validator-dialog.component.scss'],
})
export class SequenceValidatorDialogComponent {
  public periods: PeriodDto[] = [];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {
    this.periods = config.data.periods;
  }

  cancel() {
    this.ref.close(false);
  }

  confirm() {
    this.ref.close(this.periods);
  }
}
